import commonIndex from '../core'

import basePlugins from '../core/basePlugins.js'
import webrtc from '../../packages/kandy/src/webrtc'
import callMeAuth from '../../packages/kandy/src/auth/callMe'
import newCallMe from '../../packages/kandy/src/call/newCallMe'
import connectivity from '../../packages/kandy/src/connectivity/link'
import notifications from '../../packages/kandy/src/notifications/link'
import { linkRequest } from '../../packages/kandy/src/request'
import '../../packages/kandy/src/docs/docs'

import { createCodecRemover } from '@kandy-io/sdp-handlers'

const defaultPlugins = [
  ...basePlugins,
  { name: 'authentication', fn: callMeAuth },
  { name: 'webrtc', fn: webrtc },
  { name: 'call', fn: newCallMe },
  { name: 'connectivity', fn: connectivity },
  { name: 'notifications', fn: notifications },
  { name: 'request', fn: linkRequest }
]

function root (options = {}, plugins = []) {
  return commonIndex(options, [...defaultPlugins, ...plugins])
}

// Alias 'create' to be equal to the root function
root.create = root

root.sdpHandlers = {
  createCodecRemover
}
// Export this way as a work-around, so it can be used as `<export>();`.
// See: https://github.com/webpack/webpack/issues/706
module.exports = root
